import { reportData } from '../api/report';

class HeyboxReport {
  constructor() {
    this.observer = null;
    this.isScroll = false;
    this._stayStatusMap = {};
    this.isIntersectionObserverSupported = judgeIntersectionObserverSupported();
    if (this.isIntersectionObserverSupported) {
      this.init();
    }
  }

  init() {
    if (!window._stayStatusCallback) {
      window._stayStatusCallback = () => {
        return JSON.stringify(this._stayStatusMap);
      };
    }
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (
            entry.target &&
            entry.boundingClientRect &&
            !(
              entry.boundingClientRect.width +
                entry.boundingClientRect.height ===
              0
            ) &&
            entry.intersectionRect &&
            !(
              entry.intersectionRect.width + entry.intersectionRect.height ===
              0
            )
          ) {
            const modifier = entry.target._modifier;
            if (modifier === 'exposure') {
              this.exposureCallback(entry);
              return;
            } else if (modifier === 'stay') {
              this.stayCallback(entry);
            }
          }
        });
      },
      { threshold: 0.75 }
    );
  }

  add(el) {
    if (!this.isIntersectionObserverSupported) {
      return;
    }
    this.observer && this.observer.observe(el);
  }

  remove(el) {
    if (!this.isIntersectionObserverSupported) {
      return;
    }
    this.observer && this.observer.unobserve(el);
  }

  // 曝光逻辑
  exposureCallback(entry) {
    const data = entry.target._reportParam;
    if (entry.intersectionRatio >= (data.threshold || 0.5)) {
      if (this.isScroll) {
        // 对于快速滚动的场景，需要延迟检测是否停留在可视区域
        if (entry.target.getAttribute('data-report-timer')) return;

        let timer = setTimeout(() => {
          const rect = entry.target.getBoundingClientRect();
          if (rect.y < 0 || rect.y > window.innerHeight) return;

          report('exposure', data);
          entry.target.removeAttribute('data-report-timer');
          this.remove(entry.target);
        }, 500);
        entry.target.setAttribute('data-report-timer', timer);
      } else {
        report('exposure', data);
        this.remove(entry.target);
      }
    } else {
      const timer = entry.target.getAttribute('data-report-timer');
      if (timer) {
        clearTimeout(timer);
        entry.target.removeAttribute('data-report-timer');
      }
    }
  }

  // 停留时长逻辑
  stayCallback(entry) {
    let { key } = entry.target._reportParam;
    if (entry.isIntersecting) {
      this.setStayStatus(key, new Date().getTime());
    } else {
      let startTime = this.getStayStatus(key);
      if (startTime) {
        this.clearStayStatus(key);
        report('stay', {
          stay: String((new Date().getTime() - startTime) / 1000),
          ...entry.target._reportParam,
        });
      }
    }
  }

  setStayStatus(key, status) {
    this._stayStatusMap[key] = status;
  }

  getStayStatus(key) {
    return this._stayStatusMap[key];
  }

  clearStayStatus(key) {
    this.setStayStatus(key, undefined);
  }
}

export async function report(reportType, reportParam) {
  let { event_type, addition = {}, stay } = reportParam;
  if (!event_type) {
    console.error('[v-report directive] event_type is required')
    return
  }
  if (typeof addition == 'function') {
    try {
      addition = { ...await addition() };
    } catch(e) {
      addition = {};
    }
  } 
  if (reportType === 'stay') {
    addition.stay = stay;
  }
  reportData(`${reportType}:${event_type}`, addition);
}

function bind(el, binding) {
  const modifiers = binding.modifiers;
  const modifier = Object.keys(binding.modifiers).find((key) => modifiers[key]);
  el._reportParam = {
    ...(typeof binding.value == 'function'
      ? binding.value()
      : binding.value || {}),
    key: generateRandomString(),
  };
  el._modifier = modifier;

  switch (modifier) {
    // 主页面展示上报
    case 'visit':
      report('visit', el._reportParam);
      break;
    // 点击上报
    case 'click':
      el.addEventListener('click', () => {
        report('click', el._reportParam);
      });
      break;
    // 曝光上报
    case 'exposure':
      if (!window.HeyboxReport) {
        window.HeyboxReport = new HeyboxReport();
      }
      window.HeyboxReport.add(el);
      break;
    // 停留时长
    case 'stay':
      if (!window.HeyboxReport) {
        window.HeyboxReport = new HeyboxReport();
      }
      window.HeyboxReport.add(el);
      break;
    default:
      break;
  }
}

function unbind(el, binding) {
  let modifier = el._modifier;

  switch (modifier) {
    case 'exposure':
      window.HeyboxReport.remove(el);
      break;
    case 'stay':
      let { key } = el._reportParam;
      window.HeyboxReport.clearStayStatus(key);
      window.HeyboxReport.remove(el);
      break;
    default:
      break;
  }
}

function judgeIntersectionObserverSupported() {
  return (
    'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype
  );
}

function generateRandomString() {
  return [...Array(16)]
    .map(() => (~~(Math.random() * 36)).toString(36))
    .join('');
}

export const HeyboxReportDirectiveOptions = {
  bind,
  unbind,
};

const install = (Vue) => {
  Vue.directive('report', HeyboxReportDirectiveOptions);
};

export default install;
